import { State } from '../types';
import { alabama } from './states/alabama';
import { alaska } from './states/alaska';
import { arizona } from './states/arizona';
import { arkansas } from './states/arkansas';
import { california } from './states/california';
import { colorado } from './states/colorado';
import { connecticut } from './states/connecticut';
import { delaware } from './states/delaware';
import { florida } from './states/florida';
import { georgia } from './states/georgia';
import { hawaii } from './states/hawaii';
import { idaho } from './states/idaho';
import { illinois } from './states/illinois';
import { indiana } from './states/indiana';
import { iowa } from './states/iowa';
import { kansas } from './states/kansas';
import { kentucky } from './states/kentucky';
import { louisiana } from './states/louisiana';
import { maine } from './states/maine';
import { maryland } from './states/maryland';
import { massachusetts } from './states/massachusetts';
import { michigan } from './states/michigan';
import { minnesota } from './states/minnesota';
import { mississippi } from './states/mississippi';
import { missouri } from './states/missouri';
import { montana } from './states/montana';
import { nebraska } from './states/nebraska';
import { nevada } from './states/nevada';
import { newHampshire } from './states/new-hampshire';
import { newJersey } from './states/new-jersey';
import { newMexico } from './states/new-mexico';
import { newYork } from './states/new-york';
import { northCarolina } from './states/north-carolina';
import { northDakota } from './states/north-dakota';
import { ohio } from './states/ohio';
import { oklahoma } from './states/oklahoma';
import { oregon } from './states/oregon';
import { pennsylvania } from './states/pennsylvania';
import { rhodeIsland } from './states/rhode-island';
import { southCarolina } from './states/south-carolina';
import { southDakota } from './states/south-dakota';
import { tennessee } from './states/tennessee';
import { texas } from './states/texas';
import { utah } from './states/utah';
import { vermont } from './states/vermont';
import { virginia } from './states/virginia';
import { washington } from './states/washington';
import { westVirginia } from './states/west-virginia';
import { wisconsin } from './states/wisconsin';
import { wyoming } from './states/wyoming';

export const states: State[] = [
  alabama,
  alaska,
  arizona,
  arkansas,
  california,
  colorado,
  connecticut,
  delaware,
  florida,
  georgia,
  hawaii,
  idaho,
  illinois,
  indiana,
  iowa,
  kansas,
  kentucky,
  louisiana,
  maine,
  maryland,
  massachusetts,
  michigan,
  minnesota,
  mississippi,
  missouri,
  montana,
  nebraska,
  nevada,
  newHampshire,
  newJersey,
  newMexico,
  newYork,
  northCarolina,
  northDakota,
  ohio,
  oklahoma,
  oregon,
  pennsylvania,
  rhodeIsland,
  southCarolina,
  southDakota,
  tennessee,
  texas,
  utah,
  vermont,
  virginia,
  washington,
  westVirginia,
  wisconsin,
  wyoming,
];